"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfChangePasswordResponseDto = instanceOfChangePasswordResponseDto;
exports.ChangePasswordResponseDtoFromJSON = ChangePasswordResponseDtoFromJSON;
exports.ChangePasswordResponseDtoFromJSONTyped = ChangePasswordResponseDtoFromJSONTyped;
exports.ChangePasswordResponseDtoToJSON = ChangePasswordResponseDtoToJSON;
exports.ChangePasswordResponseDtoToJSONTyped = ChangePasswordResponseDtoToJSONTyped;
/**
 * Check if a given object implements the ChangePasswordResponseDto interface.
 */
function instanceOfChangePasswordResponseDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function ChangePasswordResponseDtoFromJSON(json) {
    return ChangePasswordResponseDtoFromJSONTyped(json, false);
}
function ChangePasswordResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'status': json['status'],
        'message': json['message'],
        'data': json['data'] == null ? undefined : json['data'],
        'error': json['error'] == null ? undefined : json['error'],
        'meta': json['meta'] == null ? undefined : json['meta'],
        'traceId': json['traceId'] == null ? undefined : json['traceId'],
    };
}
function ChangePasswordResponseDtoToJSON(json) {
    return ChangePasswordResponseDtoToJSONTyped(json, false);
}
function ChangePasswordResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'statusCode': value['statusCode'],
        'status': value['status'],
        'message': value['message'],
        'data': value['data'],
        'error': value['error'],
        'meta': value['meta'],
        'traceId': value['traceId'],
    };
}
